import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AppState } from '../store'
import { reset } from '../store/modules/calcReversal'
import { Modal } from './Modal'

interface CalcReversalErrorModalProps {
  inputErrorMessage: string
  resetInputErrorMessage: () => void
}

export const CalcReversalErrorModal: FC<CalcReversalErrorModalProps> = React.memo((props) => {
  const { responseCode } = useSelector((state: AppState) => state.calcReversal)
  const [showModal, setShowModal] = useState(false)
  const dispatch = useDispatch()
  useEffect(() => {
    if (showModal) {
      document.body.setAttribute('style', 'overflow: hidden;')
    } else {
      document.body.removeAttribute('style')
    }

    return () => document.body.removeAttribute('style')
  }, [showModal])

  const responseErrorMessage = useMemo(() => {
    if (responseCode === 1) {
      return '計算結果が上限を超えています。ご利用方法を確認してください。'
    } else if (responseCode === 2) {
      return '計算結果が上限を超えたため、評価額が目標額を達成できません。ご利用方法を確認してください。'
    } else if (responseCode === 10) {
      return '入力された値が不正です。'
    } else if (responseCode !== 0) {
      return 'サーバーエラーが発生しました。'
    } else {
      return ''
    }
  }, [responseCode])

  const handleHide = useCallback(() => {
    dispatch(reset())
    props.resetInputErrorMessage()
    setShowModal(false)
  }, [dispatch, props])

  useEffect(() => {
    if (responseCode !== 0 || props.inputErrorMessage !== '') {
      setShowModal(true)
    }
  }, [props.inputErrorMessage, responseCode, setShowModal])

  return (
    <React.Fragment>
      {showModal && (
        <Modal>
          <div className="c-dialog">
            <div className="c-dialog__content">
              <div className="c-dialog__head">
                <p>入力エラー</p>
              </div>
              <div className="c-dialog__body">
                {props.inputErrorMessage && <p>{props.inputErrorMessage}</p>}
                {responseErrorMessage && <p>{responseErrorMessage}</p>}
                <div className="c-dialog__button-wrap">
                  <button className="c-dialog__button" onClick={handleHide}>
                    OK
                  </button>
                </div>
              </div>
            </div>
            <div className="c-dialog__overlay" onClick={handleHide}></div>
          </div>
        </Modal>
      )}
    </React.Fragment>
  )
})
